import React from 'react';
import '../template-file-css/document-file-template.css';



export const RRTS_RecipientSafetyPlan = ({
    itemsRef,
    showErrorFor,
    
}) => {

    return (
        <form id='RRTS_RecipientSafetyPlan' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'> <h3>Recipient Safety Plan</h3> </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Step 1:	Warning signs (thoughts, images, mood, situation, behavior) that a crisis may be developing: </span>
                        </td>
                    </tr>
                    <tr>
                        1. <td className='w-750'> <input type='text' id='txtWarningSignsThoughtsImagesMoodSituationBehaviorThatCrisisMayBeDevloping' name='txtWarningSignsThoughtsImagesMoodSituationBehaviorThatCrisisMayBeDevloping' className='add-only' /> </td>
                    </tr>
                    <tr>
                        2. <td className='w-750'> <input type='text' id='txtWarningSignsThoughtsImagesMoodSituationBehaviorThatCrisisMayBeDevloping_1' name='txtWarningSignsThoughtsImagesMoodSituationBehaviorThatCrisisMayBeDevloping_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        3. <td className='w-750'> <input type='text' id='txtWarningSignsThoughtsImagesMoodSituationBehaviorThatCrisisMayBeDevloping_2' name='txtWarningSignsThoughtsImagesMoodSituationBehaviorThatCrisisMayBeDevloping_2' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Step 2:	Internal coping strategies - Things I can do to take my mind off my problems without contacting another person (relaxation technique, physical activity): </span>
                        </td>
                    </tr>
                    <tr>
                        1. <td className='w-750'> <input type='text' id='txtInternalCopingStrategiesThingsCanDoToTakeMyMindOffMyProblemsWithoutContactingAnotherPersonRelaxationTechniquePhysicalActivity' name='txtInternalCopingStrategiesThingsCanDoToTakeMyMindOffMyProblemsWithoutContactingAnotherPersonRelaxationTechniquePhysicalActivity' className='add-only' /> </td>
                    </tr>
                    <tr>
                        2.  <td className='w-750'> <input type='text' id='txtInternalCopingStrategiesThingsCanDoToTakeMyMindOffMyProblemsWithoutContactingAnotherPersonRelaxationTechniquePhysicalActivity_1' name='txtInternalCopingStrategiesThingsCanDoToTakeMyMindOffMyProblemsWithoutContactingAnotherPersonRelaxationTechniquePhysicalActivity_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        3.  <td className='w-750'> <input type='text' id='txtInternalCopingStrategiesThingsCanDoToTakeMyMindOffMyProblemsWithoutContactingAnotherPersonRelaxationTechniquePhysicalActivity_2' name='txtInternalCopingStrategiesThingsCanDoToTakeMyMindOffMyProblemsWithoutContactingAnotherPersonRelaxationTechniquePhysicalActivity_2' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>Step 3: People and social settings that provide distraction: </b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>1.	Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtName_1' name='txtName_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhone_1' name='txtPhone_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>2.	Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtName_2' name='txtName_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhone_2' name='txtPhone_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>3.	Place</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>4. Place</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPlace_1' name='txtPlace_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPlace_2' name='txtPlace_2' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>Step 4: People whom I can ask for help: </b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>1.	Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtPeopleWhomCanAskForHelpName_1' name='txtPeopleWhomCanAskForHelpName_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPeopleWhomCanAskForHelpPhone_1' name='txtPeopleWhomCanAskForHelpPhone_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>2.	Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtPeopleWhomCanAskForHelpName_2' name='txtPeopleWhomCanAskForHelpName_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPeopleWhomCanAskForHelpPhone_2' name='txtPeopleWhomCanAskForHelpPhone_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>3.	Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtPeopleWhomCanAskForHelpName_3' name='txtPeopleWhomCanAskForHelpName_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPeopleWhomCanAskForHelpPhone_3' name='txtPeopleWhomCanAskForHelpPhone_3' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>Step 5: Professionals or agencies I can contact during a crisis: </b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>1. Staff Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtProffessionalAgenciesStaffName' name='txtProffessionalAgenciesStaffName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtProffessionalAgenciesPhone_1' name='txtProffessionalAgenciesPhone_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>2. Clinician Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtProffessionalAgenciesClinicianName' name='txtProffessionalAgenciesClinicianName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtProffessionalAgenciesPhone_2' name='txtProffessionalAgenciesPhone_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>3. Local Urgent Care Services:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtLocalUrgentCareServicesName_3' name='txtLocalUrgentCareServicesName_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLocalUrgentCareServicesPhone_3' name='txtLocalUrgentCareServicesPhone_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Address:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtLocalUrgentAddress' name='txtLocalUrgentAddress' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>4. Suicide Prevention Lifeline Phone: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtSuicidePreventionLifelinPhone' name='txtSuicidePreventionLifelinPhone' className='add-only' placeholder='1-800-273-TALK (8255) '/>
                        </td>
                    </tr>
                </table>  



            </div>
        </form>

    )
}  
